(function(_){
    'use strict';
    _['OUTLETS.KEY']='Ofertas';
    _['OUTLETS.NO-PROMOTIONS']='Não há ofertas disponíveis';
}(translations['pt']));


// WEBPACK FOOTER //
// ./src/app/modules/outlets/lang/outlets-lang_pt.js